import { FC, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deliveryActions } from "../store/delivery.slice";

const DeliveryLayout: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(deliveryActions.reset());
    };
  }, [dispatch]);

  return <Outlet />;
};

export default DeliveryLayout;
